var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoX = function SvgLogoX(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "logo_lockups",
    "data-name": "logo lockups",
    viewBox: "0 0 165.96 165.96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs206"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 63.96,
    x2: 63.96,
    y1: 125.27,
    y2: 194.64,
    gradientTransform: "translate(-45.02 -45.024)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    offset: 0.1,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    offset: 0.15,
    stopColor: "#231f20",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    offset: 0.21,
    stopColor: "#231f20",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop8",
    offset: 0.26,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop10",
    offset: 0.5,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop12",
    offset: 0.63,
    stopColor: "#231f20",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop14",
    offset: 0.77,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 73.73,
    x2: 74.77,
    y1: 205.7,
    y2: 160.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop17",
    offset: 0.03,
    stopColor: "#c6cdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop19",
    offset: 0.21,
    stopColor: "#c6cdc9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop21",
    offset: 0.6,
    stopColor: "#c6cdc9",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop23",
    offset: 0.87,
    stopColor: "#c6cdc9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop25",
    offset: 1,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1755.66,
    x2: 1778.92,
    y1: -4905.18,
    y2: -4841.3,
    gradientTransform: "scale(1 -1) rotate(-35.41 8464.652 28.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop28",
    offset: 0.11,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop30",
    offset: 0.13,
    stopColor: "#a3bfd9",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop32",
    offset: 0.26,
    stopColor: "#a3bfd9",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop34",
    offset: 0.37,
    stopColor: "#a3bfd9",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop36",
    offset: 0.45,
    stopColor: "#a3bfd9",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop38",
    offset: 0.49,
    stopColor: "#a3bfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop40",
    offset: 0.66,
    stopColor: "#a3bfd9",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop42",
    offset: 0.82,
    stopColor: "#a3bfd9",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop44",
    offset: 0.94,
    stopColor: "#a3bfd9",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46",
    offset: 1,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 174.65,
    x2: 116.24,
    y1: 71.51,
    y2: 164.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop49",
    offset: 0,
    stopColor: "#392726"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop51",
    offset: 0.24,
    stopColor: "#392726",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop53",
    offset: 0.54,
    stopColor: "#392726",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop55",
    offset: 0.87,
    stopColor: "#392726",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop57",
    offset: 1,
    stopColor: "#392726",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 55.54,
    x2: 96.9,
    y1: 157.42,
    y2: 198.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop60",
    offset: 0.18,
    stopColor: "#c6cdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop62",
    offset: 0.25,
    stopColor: "#c6cdc9",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop64",
    offset: 0.38,
    stopColor: "#c6cdc9",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop66",
    offset: 0.57,
    stopColor: "#c6cdc9",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop68",
    offset: 0.79,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0.8,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 56.05,
    x2: 108.88,
    y1: 152.83,
    y2: 215.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop73",
    offset: 0,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop75",
    offset: 0.05,
    stopColor: "#c6cdc9",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop77",
    offset: 0.1,
    stopColor: "#c6cdc9",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop79",
    offset: 0.16,
    stopColor: "#c6cdc9",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop81",
    offset: 0.21,
    stopColor: "#c6cdc9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop83",
    offset: 0.27,
    stopColor: "#c6cdc9",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop85",
    offset: 0.31,
    stopColor: "#c6cdc9",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop87",
    offset: 0.36,
    stopColor: "#c6cdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop89",
    offset: 0.46,
    stopColor: "#c6cdc9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop91",
    offset: 0.56,
    stopColor: "#c6cdc9",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop93",
    offset: 0.66,
    stopColor: "#c6cdc9",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop95",
    offset: 0.75,
    stopColor: "#c6cdc9",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop97",
    offset: 0.83,
    stopColor: "#c6cdc9",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop99",
    offset: 0.88,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -900.07,
    x2: -826.74,
    y1: -249.22,
    y2: -161.83,
    gradientTransform: "rotate(-26.56 420.804 -2158.144)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop102",
    offset: 0,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop104",
    offset: 0.02,
    stopColor: "#a3bfd9",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop106",
    offset: 0.1,
    stopColor: "#a3bfd9",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop108",
    offset: 0.17,
    stopColor: "#a3bfd9",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop110",
    offset: 0.24,
    stopColor: "#a3bfd9",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop112",
    offset: 0.31,
    stopColor: "#a3bfd9",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop114",
    offset: 0.37,
    stopColor: "#a3bfd9",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop116",
    offset: 0.41,
    stopColor: "#a3bfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop118",
    offset: 0.53,
    stopColor: "#a3bfd9",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop120",
    offset: 0.69,
    stopColor: "#a3bfd9",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop122",
    offset: 0.84,
    stopColor: "#a3bfd9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop124",
    offset: 0.94,
    stopColor: "#a3bfd9",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop126",
    offset: 1,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 238.12,
    cy: -71.84,
    r: 57,
    fx: 238.12,
    fy: -71.84,
    gradientTransform: "matrix(1.11 0 0 1.14 -246.8 236.646)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop129",
    offset: 0.05,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop131",
    offset: 0.31,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop133",
    offset: 0.64,
    stopColor: "#4693bc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop135",
    offset: 0.65,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop137",
    offset: 0.86,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop139",
    offset: 1,
    stopColor: "#c6cdc9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1487.53,
    cy: -2205.57,
    r: 77.58,
    fx: 1487.53,
    fy: -2205.57,
    gradientTransform: "matrix(-.32492 1.09271 .81072 .2558 2473.24 -1004.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop142",
    offset: 0,
    stopColor: "#f2c03e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop144",
    offset: 0.06,
    stopColor: "#efb63a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop146",
    offset: 0.17,
    stopColor: "#e99e30"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop148",
    offset: 0.3,
    stopColor: "#df7521"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop150",
    offset: 0.45,
    stopColor: "#d13e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop152",
    offset: 0.52,
    stopColor: "#ca2100"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop154",
    offset: 0.57,
    stopColor: "#bd1e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop156",
    offset: 0.67,
    stopColor: "#9b1900"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop158",
    offset: 0.8,
    stopColor: "#651000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop160",
    offset: 0.95,
    stopColor: "#1a0400"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop162",
    offset: 1,
    stopColor: "#010000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1267.95,
    cy: -4907.72,
    r: 26.22,
    fx: 1267.95,
    fy: -4907.72,
    gradientTransform: "matrix(.88046 .65939 .62754 -.9293 2138.46 -5312.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop165",
    offset: 0.54,
    stopColor: "#edcb48"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop167",
    offset: 0.58,
    stopColor: "#edcb48",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop169",
    offset: 0.63,
    stopColor: "#edcb48",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop171",
    offset: 0.7,
    stopColor: "#edcb48",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop173",
    offset: 0.77,
    stopColor: "#edcb48",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop175",
    offset: 0.85,
    stopColor: "#edcb48",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop177",
    offset: 0.93,
    stopColor: "#edcb48",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop179",
    offset: 0.96,
    stopColor: "#edcb48",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#radial-gradient-2",
    id: "radial-gradient-4",
    cx: 680.59,
    cy: -75.25,
    r: 113.12,
    fx: 680.59,
    fy: -75.25,
    gradientTransform: "matrix(.5826 -1.10593 .62006 .17466 -276.4 961.82)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -243.55,
    cy: -604.16,
    r: 127.92,
    fx: -243.55,
    fy: -604.16,
    gradientTransform: "matrix(.09887 -1.27618 .76143 -.11847 662 -188.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop183",
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop185",
    offset: 0.25,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop187",
    offset: 0.27,
    stopColor: "#25272b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop189",
    offset: 0.32,
    stopColor: "#304a59"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop191",
    offset: 0.37,
    stopColor: "#38667f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop193",
    offset: 0.43,
    stopColor: "#3f7c9d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop195",
    offset: 0.48,
    stopColor: "#448cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop197",
    offset: 0.53,
    stopColor: "#4795be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop199",
    offset: 0.57,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop201",
    offset: 0.83,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop203",
    offset: 1,
    stopColor: "#c6cdc9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#radial-gradient-2",
    id: "radialGradient405",
    cx: 1487.53,
    cy: -2205.57,
    r: 77.58,
    fx: 1487.53,
    fy: -2205.57,
    gradientTransform: "matrix(-.32492 1.09271 .81072 .2558 2473.24 -1004.9)",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M34.95 87.176C14.13 85.396 2 103.286 2 121.056c0 .9.02 1.8.06 2.68l.11-.77c.06 1.52.27 3.1.44 4.56.08.67.43 2.09.54 2.75 2.39 8.03 7.21 12.6 14.32 12.6 10.32 0 22.75-10.32 31.67-26.29 1.14-2.05 2.33-4.26 3.52-6.56 1.11-2.14 3.11-6.23 5.1-10.35-4.36-6.51-10.93-11.48-22.81-12.49Z",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M27.7 87.376c-6.01 1.48-11.58 5.18-15.44 10.11-6.77 8.65-10.36 23.06-4.12 33.02 2.66 4.25 7.05 6.41 11.93 6.26 2.6-.08 10.45-.83 15.81-3.6-5.97 5.65-14.91 11.42-23.34 8.26-7.01-2.63-9.75-10.55-10.46-17.58-.04-.92-.07-1.84-.07-2.78 0-15.59 9.34-31.27 25.69-33.68z",
    style: {
      opacity: 0.5,
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g214",
    style: {
      opacity: 0.65
    },
    transform: "translate(-45.02 -45.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "M48.64 177.81c2.37 8.12 6.69 10.09 13.85 10.09 10.32 0 22.75-10.32 31.67-26.29 1.14-2.05 2.33-4.26 3.52-6.56 1.08-2.09 3.01-6.03 4.95-10.05a9.34 9.34 0 0 0-.44-.45c-6.54-6.53-15.05-4.67-19.18-.63-10.64 10.41-4.75 37.11-22.62 38.84-9.86.95-12.66-7.38-13.32-14.22 0 .08 0 .15.01.23.09 2.17 1.24 6.99 1.56 9.04z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g240",
    transform: "translate(-45.02 -45.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "M116.37 116.3c6.81-13 12.71-23.81 18.14-31.91 14.23-22.52 31.91-35.81 54.32-19.03 13.46 10.08 19.3 25.98 19.74 41.85.02.42-.15.94-.58 1-.35.05-.65-.28-.76-.7-1.05-3.71-2.83-6.63-5.56-8.67-7.12-5.33-16.83 1.69-27.11 17.59-3.34 5.17-8.01 13.31-13.36 23.04",
    style: {
      fill: "url(#radialGradient405)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M134.51 84.38c14.23-22.52 31.91-35.81 54.32-19.03 8.65 6.48 14.15 15.35 17.09 25.08-1.37-3.24-3-6.34-4.87-9.25-6.66-10.3-17.54-19.72-29.79-20.57-12.28-.85-22.16 8.24-29.57 17.53",
    style: {
      opacity: 0.25,
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g222",
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M181.64 71.04c-9.08-3.55-16.34-1.47-21.54 2.21-13.81 9.81-19.19 2-19.19 2 13.05-16.59 28.75-24.24 47.91-9.89 13.05 9.77 18.93 25 19.68 40.37-1.07-7.33-8.48-27.5-26.87-34.69z",
    style: {
      opacity: 0.5,
      fill: "url(#radial-gradient-3)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M160.67 116.53c1.37-17.13.08-26.96-4.19-31.87-2.08-2.39-4.93-3.61-8.46-3.63-5.71.03-11.18 3.06-16.81 9.4-3.11 4.32-6.06 8.96-8.89 13.83-2.23 3.84-10.07 19.13-11.81 22.85-1.03 2.2-8.65 18.59-11.3 23.86-1.23 2.44-2.45 4.77-3.66 7-9.3 17.11-21.97 27.81-32.47 27.81-8.78 0-14.84-7.1-16.05-19.84 1.01 24.73 15.14 43.02 41.27 43.02 7.09 0 14.15-1.47 20.7-4.35 15.55-6.85 28.05-21.2 38.7-38.96 2.63-4.26 5.26-9.08 7.94-14.39.21-.42.59-1.2 1.1-2.27.68-4.89 1.37-9.9 2.05-15.03.9-7.01 1.5-12.55 1.89-17.44z",
    style: {
      fill: "url(#radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M160.67 116.53c1.37-17.13.08-26.96-4.19-31.87-2.08-2.39-4.93-3.61-8.46-3.63-5.7.03-11.16 3.04-16.78 9.37-1.05 1.45-2.08 2.93-3.09 4.45 6.7-8.5 12.54-12.72 19.75-11.87 9.81 1.16 9.36 20.45 4.22 43.95-1.31 5.97-2.89 12.42-4.65 19.28-3.01 11.56-6.01 22.59-8.71 32.85 3.12-4.17 6.1-8.66 8.94-13.4 2.63-4.26 5.26-9.08 7.94-14.39.21-.42.59-1.2 1.1-2.27.68-4.89 1.37-9.9 2.05-15.03.9-7.01 1.5-12.55 1.89-17.44z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g230",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "M88.29 208.98c-6.21-.55-13.37-3.4-15.24-9.49-3.09-10.04 8.75-17.17 21.5-39.74-9.19 16.07-21.34 26.04-31.48 26.04-8.78 0-14.84-7.11-16.05-19.85 1 24.74 15.14 43.04 41.27 43.04z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "M47.13 167.66c.04.42.07.83.08 1.24 1.98 23.22 16.01 40.07 41.08 40.07 14.3 0 26.42-5.67 36.95-15-7.63 5.11-15.67 9.16-24.14 10.91-4.22.93-8.52 1.26-12.8 1.19-4.29-.19-8.51-.73-12.55-1.91a35.07 35.07 0 0 1-11.15-5.66 35.136 35.136 0 0 1-8.65-9.45c-6.89-11.04-8.41-17.62-8.93-23.07.01.36.04.71.06 1.07.02.2.03.41.05.61z",
    style: {
      opacity: 0.15,
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "M208.98 139.85c-1.61 10.87-5.01 18.53-11.14 21.75-9.16 4.82-15.66-4.94-22.08-21.94-3.13-8.29-6.25-18.31-9.65-29.2-1.4-4.47-2.84-9.09-4.35-13.79-1.66-5.12-6.15-17.36-6.72-18.74-9.6-23.4-21.91-38.9-45.35-26.55-19.24 10.13-27 30.82-29.64 55.24 1.52-11.6 4.74-19.73 11.1-23.12 9.13-4.76 15.63 5 22.05 21.96 1.63 4.31 3.26 9.07 4.92 14.19 5.2 16.16 9.58 31.29 14 42.99 0 .02 1.54 3.94 2.37 5.91 9.39 22.43 21.5 37.45 44.49 25.35 19.25-10.14 27.26-30.19 30-54.05z",
    style: {
      fill: "url(#radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M181.08 192.72c1.18-.7 2.32-1.43 3.44-2.23 10.37-7.37 16.79-18.19 20.62-31.07-.04.11-.08.22-.13.34-1.43 3.75-3.19 7.33-5.18 10.71-4.32 7.39-10.23 13.79-17.24 18.39-6.99 4.59-15.59 8.42-23.92 6.05-7.91-2.25-13.49-9.55-17.57-16.63-4.44-7.71-7.65-16.13-10.72-24.52-3.25-8.92-6.55-17.82-9.9-26.69 4.2 13.34 7.91 25.68 11.65 35.57 0 .02 1.54 3.94 2.37 5.91 9.39 22.43 21.5 37.45 44.49 25.35.71-.37 1.41-.77 2.1-1.18z",
    style: {
      opacity: 0.25,
      fill: "url(#linear-gradient-7)"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo-x.794a8f7.svg";